import { Pipe, PipeTransform } from '@angular/core';
import {User} from '@app/models/vcr-entity/user';
import {LocalUser} from '@app/state/local-user.state';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {RemoteUserAdditionalInfoStateModel} from '@app/state/remote-users.state';

@Pipe({
  name: 'fullName'
})
export class FullNamePipe implements PipeTransform {
  public transform(user: User | LocalUser | RemoteParticipantInfo | RemoteUserAdditionalInfoStateModel): string {
    if (user.firstName && user.lastName) {
      return user.firstName + ' ' + user.lastName;
    } else if (user.firstName) {
      return user.firstName;
    } else if (user.lastName) {
      return user.lastName;
    } else {
      return user.name;
    }
  }
}
